import { render, staticRenderFns } from "./DictTypeForm.vue?vue&type=template&id=29c1734e"
import script from "./DictTypeForm.vue?vue&type=script&lang=js"
export * from "./DictTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29c1734e')) {
      api.createRecord('29c1734e', component.options)
    } else {
      api.reload('29c1734e', component.options)
    }
    module.hot.accept("./DictTypeForm.vue?vue&type=template&id=29c1734e", function () {
      api.rerender('29c1734e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/sys/dict/DictTypeForm.vue"
export default component.exports